module.exports = __webpack_public_path__ + "static/media/Graph_Ote.16cd65af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Graph_Ote.png
// module id = 157
// module chunks = 1